import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { PriceOptionControlComponent } from './price-option-control.component';

@NgModule({
  declarations: [
    PriceOptionControlComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    PriceOptionControlComponent,
  ],
  entryComponents: [
    PriceOptionControlComponent
  ],
})
export class PriceOptionControlModule { }
